if (!customElements.get('product-description')) {
  customElements.define('product-description', class ProductDescription extends HTMLElement {
    connectedCallback() {
      // Also runs when Shopify replaces a product or reloads its section in the editor.
      requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.formatContainer(this);
        this.querySelectorAll('ul').forEach(list => list.setAttribute('role', 'list'));
        this.querySelectorAll('[data-description-checklist]').forEach(list => {
          let next = list.nextSibling;
          while (next) {
            if (next.nodeType === Node.TEXT_NODE && !next.textContent.trim()) {
              next = next.nextSibling;
            } else if (next.nodeType === Node.ELEMENT_NODE && next.hasAttribute('data-description-checklist')) {
              list.append(...next.childNodes);
              const merged = next;
              next = next.nextSibling;
              merged.remove();
            } else {
              break;
            }
          }
        });
      });
    }

    formatContainer(container) {
      const blocks = 'p,div,ul,ol,table,pre,blockquote,h1,h2,h3,h4,h5,h6,section,figure,hr,script,style';
      let inline = [];
      const flush = () => {
        if (!inline.length) return;
        const source = document.createElement('div');
        inline.forEach(node => source.append(node.cloneNode(true)));
        const formatted = this.formatLines(source);
        if (formatted) {
          inline[0].before(formatted);
          inline.forEach(node => node.remove());
        }
        inline = [];
      };
      [...container.childNodes].forEach(node => {
        if (node.nodeType !== Node.ELEMENT_NODE || !node.matches(blocks)) {
          inline.push(node);
          return;
        }
        flush();
        if (node.matches('p') && !node.querySelector(blocks)) {
          const formatted = this.formatLines(node);
          if (formatted) node.replaceWith(formatted);
        } else if (node.matches('div,section')) {
          this.formatContainer(node);
        }
      });
      flush();
    }

    formatLines(source) {
      const lines = [];
      const range = document.createRange();
      range.setStart(source, 0);
      const walker = document.createTreeWalker(source, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR') {
          range.setEndBefore(node);
          lines.push(range.cloneContents());
          range.setStartAfter(node);
        } else if (node.nodeType === Node.TEXT_NODE && !node.parentElement.closest('code,pre')) {
          // HTML source wrapping stays intact; only a new starred line starts another item.
          for (const match of node.textContent.matchAll(/\r?\n(?=[\t ]*\*\s+\S)/g)) {
            range.setEnd(node, match.index);
            lines.push(range.cloneContents());
            range.setStart(node, match.index + match[0].length);
          }
        }
      }
      range.setEnd(source, source.childNodes.length);
      lines.push(range.cloneContents());

      const markers = lines.map(line => line.textContent.match(/^\s*\*\s+(?=\S)/));
      if (!markers.some(Boolean)) return null;

      const output = document.createDocumentFragment();
      let list;
      let paragraph;
      lines.forEach((line, index) => {
        if (markers[index]) {
          // Remove just the marker, retaining links, emphasis and other inline markup.
          let remaining = markers[index][0].length;
          const text = document.createTreeWalker(line, NodeFilter.SHOW_TEXT);
          while (remaining && (node = text.nextNode())) {
            const removed = Math.min(remaining, node.textContent.length);
            node.textContent = node.textContent.slice(removed);
            remaining -= removed;
          }
          if (!list) {
            list = document.createElement('ul');
            list.setAttribute('data-description-checklist', '');
            output.append(list);
          }
          const item = document.createElement('li');
          item.append(line);
          list.append(item);
          paragraph = null;
        } else if (line.textContent.trim() || line.querySelector('img,video,iframe,svg')) {
          if (!paragraph) {
            paragraph = source.tagName === 'P' ? source.cloneNode(false) : document.createElement('p');
            output.append(paragraph);
          } else {
            paragraph.append(document.createElement('br'));
          }
          paragraph.append(line);
          list = null;
        }
      });
      return output;
    }
  });
}
